type UseCurrentLiveOptions = {
  enabled?: MaybeRefOrGetter<boolean>
  refetchOnWindowFocus?: boolean
}

export const useCurrentLive = (options?: UseCurrentLiveOptions) => {
  const { isHost } = useAuth()
  const enabled = computed(() => toValue(options?.enabled) && isHost.value)
  return useQuery({
    refetchOnWindowFocus: options?.refetchOnWindowFocus,
    enabled,
    queryKey: ['current-live'],
    queryFn: ({ signal }) =>
      $api<StreamDetails>('/stream/current-live', {
        type: UserType.STREAMER,
        method: 'POST',
        signal,
      }),
  })
}
